import { useState } from 'react';

import { Info } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { TranscriptInfoModal } from './TranscriptInfoModal';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { BackButton } from '@/components/atoms/BackButton';
import { Button } from '@/components/atoms/new-button';

export const TranscriptionHeader = ({
  transcriptName,
  transcriptCreatedDate,
  transcriptDeponent,
  transcriptObjective,
  transcriptOtherSpeakers,
  transcriptPhraseList,
  audioControls,
}: {
  transcriptName: string;
  transcriptCreatedDate: Date | string | null;
  transcriptDeponent: string | null;
  transcriptObjective: string | null;
  transcriptOtherSpeakers: string[] | null;
  transcriptPhraseList: string[] | null;
  audioControls: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const caseId = searchParams.get('caseId');

  const handleBackToTranscripts = () => {
    navigate(`/app/chronos/case-editor/transcripts?caseId=${caseId}`);
  };

  return (
    <div className="flex-shrink-0 border-b border-gray-200 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <BackButton onClick={handleBackToTranscripts} />
          <div className="h-5 w-px bg-gray-300"></div>
          <h1 className="text-sm font-semibold text-gray-900">{transcriptName}</h1>
          <Button
            onClick={() => {
              trackCustomEvent(TrackingEvents.ClickTranscriptInfoButton);
              setIsInfoModalOpen(true);
            }}
            title="Transcript information"
            size="icon"
            variant="secondary"
            className="h-6 w-6 bg-gray-50"
          >
            <Info />
          </Button>
        </div>

        <div className="flex items-center gap-3">{audioControls}</div>
      </div>
      <TranscriptInfoModal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
        transcriptName={transcriptName || ''}
        transcriptCreatedDate={transcriptCreatedDate || null}
        transcriptDeponent={transcriptDeponent || null}
        transcriptObjective={transcriptObjective || null}
        transcriptOtherSpeakers={transcriptOtherSpeakers || null}
        transcriptPhraseList={transcriptPhraseList || null}
      />
    </div>
  );
};
